module.exports = __webpack_public_path__ + "static/media/inactiveTickets.203c060f.svg";